import $ from 'jquery'
export const atriaGTMTracker = function() {

  let gtmInterval = null;

  const init = function() {
    if ('object' !== typeof dataLayer)
    {
      waitForGtm();
    }
  }

  const waitForGtm = function() {
    if (null !== gtmInterval)
    {
      return;
    }

    gtmInterval = setInterval(gtmIntervalCallback, 150)
  }

  const gtmIntervalCallback = function() {
    if ('object' === typeof dataLayer)
    {
      clearInterval(gtmInterval);
      bindEvents();
    }
  }

  const bindEvents = function() {
    bindEventClick('.atria-active-form button', 'Submit Button');
    bindEventClick('.atria-active-form input[name="email"]', 'Type Your Email Field');

    bindEventClick('.jobs-item[onclick*="job_cat=19"]', 'Care Card');
    bindEventClick('.jobs-item[onclick*="job_cat=54"]', 'Culinary Card');
    bindEventClick('.jobs-item[onclick*="job_cat=55"]', 'Housekeeping & Maintenance Card');
    bindEventClick('.jobs-item[onclick*="job_cat=56"]', 'Resident Engagement & Activities Card');
    bindEventClick('.jobs-item[onclick*="job_cat=57"]', 'Administrative Card');
    bindEventClick('.jobs-item[onclick*="job_cat=58"]', 'Executive Directors & General Managers Card');
    bindEventClick('.jobs-item[onclick*="job_cat=16"]', 'Sales Team Card');
    bindEventClick('.jobs-item[onclick*="job_cat=59"]', 'Corporate Support Center & Regional Card');
    
    bindEventClick('.cta-purple a[href="/careers/"]', 'Explore Roles Button');

    bindEventClick('.testimonial-items a[href*="job_cat=15"]', 'Search Culinary Positions');
    bindEventClick('.testimonial-items a[href*="job_cat=19"]', 'Search Care Positions');

    bindEventClick('body.home .brands-item a[href*="brand=coterie"]', 'Coterie Card');
    bindEventClick('body.home .brands-item a[href*="brand=atria-senior-living"]', 'Atria Card');
    bindEventClick('body.home .brands-item a[href*="brand=atria-retirement"]', 'Atria Retirement Card');
    bindEventClick('body.home .brands-item a[href*="brand=atria-retirement-canada"]', 'Atria Retirement Canada Card');
    bindEventClick('body.home .brands-item a[href*="brand=holiday-retirement"]', 'Holiday Retirement Card');
    bindEventClick('body.home .brands-item a[href*="brand=atria-home-care"]', 'Atria Home Care Card');
    bindEventClick('body.home .brands-item a[href*="brand=atria-support-center"]', 'Atria support center Card');

    bindEventClick('.single-careers .single-banner a.btn.btn-filled', 'Apply Now Button (Green)');
    bindEventClick('.single-careers .tabs-content .actions a.btn.btn-cta', 'Apply Now Button (White)');

    bindEventClick('.similar-jobs a.btn-cta', 'See All Available Jobs Button');
    bindEventClick('.similar-jobs .careers-list a', 'Similar Job Openings Links');

    bindEventChange('.career-search input[name="location"]', 'Location / Zip Input');
    bindEventChange('.career-search select[name="job_cat"]', 'Job Category Input');
    bindEventClick('.career-search button', 'Find Your Career Button');

    bindEventChange('.filter-form input[name="keywords"]', 'Keywords Input');
    bindEventChange('.filter-form input[name="location"]', 'Location / Zip Input');
    bindEventChange('.filter-form select[name="job_cat"]', 'Job Category Input');

    bindEventClick('body.tax-careers_brand section[role="contentinfo"] .btn-cta[href*="search_filter"]', 'See All Available Jobs Button');

    bindEventClick('.desktop-filter-row a.brands-item-small[href*="brand=43"]', 'Coterie Button');
    bindEventClick('.desktop-filter-row a.brands-item-small[href*="brand=41"]', 'Atria Button');
    bindEventClick('.desktop-filter-row a.brands-item-small[href*="brand=42"]', 'Atria Retirement Button');
    bindEventClick('.desktop-filter-row a.brands-item-small[href*="brand=40"]', 'Atria Retirement Canada Button');
    bindEventClick('.desktop-filter-row a.brands-item-small[href*="brand=45"]', 'Atria Support Center Button');
    bindEventClick('.desktop-filter-row a.brands-item-small[href*="brand=39"]', 'Atria Home Care Button');
    bindEventClick('.desktop-filter-row a.brands-item-small[href*="brand=44"]', 'Gladwell Senior Living Button');

    bindEventClick('a.toogle-video-popup', 'Watch the Video Link');

    bindEventClick('.single-careers .tabs-navi a[href="#overview"]', 'Overview Tab');
    bindEventClick('.single-careers .tabs-navi a[href="#responsibilities"]', 'Responsibilities Tab');
    bindEventClick('.single-careers .tabs-navi a[href="#hiring"]', 'Hiring Process Tab');
    
    bindEventClick('.job-row a.career-item', 'Job Links');
    bindEventClick('div#search-map', 'Map Click');
    bindEventClick('.btn-map-desktop', 'Show Map Button');
    bindEventClick('.mobile-show-map', 'Show Map Button');

    bindEventClick('.single-careers .cards-image-text a[href*="rewards-and-recognition"]', 'Rewards & Recognition Link');
    bindEventClick('.single-careers .cards-image-text a[href*="health-safety"]', 'Health & Safety Link');

    bindEventTextButton('.brand-title-block .actions a.btn-cta');


    bindEventClick('a[href="/careers/"]', 'Submit Button');
    
    bindEventClick('a[href*="brands/coterie"]', 'Submit Button');
    bindEventClick('a[href*="brands/atria-senior-living"]', 'Submit Button');
    bindEventClick('a[href*="brands/atria-retirement"]', 'Submit Button');
    bindEventClick('a[href*="brands/atria-retirement-canada"]', 'Submit Button');
    bindEventClick('a[href*="brands/holiday-retirement"]', 'Submit Button');
    bindEventClick('a[href*="brands/atria-home-care"]', 'Submit Button');
    bindEventClick('a[href*="brands/atria-support-center"]', 'Submit Button');
  }

  const bindEventTextButton = function(selector) {
    //Careers at Atria Home Care Button
    //this.text + Button
    $('body').on('click', selector, function(e) {
      const eventName = $(this).text() + ' Button'
      dataLayer.push({'event': eventName});
    })
  }
  
  const bindEventChange = function(selector, eventName) {
    $('body').on('change', selector, function(e) {
      dataLayer.push({'event': eventName});
    })
  }

  const bindEventClick = function(selector, eventName) {
    $(document).on('click', selector, function(e) {
      dataLayer.push({'event': eventName});
    })
  }

  init();
}